package demos.`fun`

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.BlurredEdgeTreatment
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.blur
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.draw.scale
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.RoundRect
import androidx.compose.ui.geometry.toRect
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Paint
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.graphics.ShaderBrush
import androidx.compose.ui.graphics.Shadow
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.addOutline
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.drawscope.drawIntoCanvas
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.toArgb
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.jetbrains.skia.ColorFilter
import org.jetbrains.skia.FilterBlurMode
import org.jetbrains.skia.ISize
import org.jetbrains.skia.MaskFilter
import org.jetbrains.skia.Shader
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.skiko.currentNanoTime
import kotlin.random.Random


const val UI_2024 = "771ff8164e0bc1bc8beeedbcaa9fd5f49d97d0ba031428f176e46c4943be3203"

@Composable
fun UI2024() {
    Box(
        Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {

        GodRays()
        Particles()
        LeatherButton()
    }
//    Column(Modifier.fillMaxSize()) {
//        Row(Modifier.weight(1f).fillMaxWidth()) {
//
//            Box(Modifier.weight(1f)) {
//
//                GodRays()
//            }
//
//            Box(
//                Modifier.fillMaxHeight().width(1.dp).background(lighterBrown)
//            )
//
//            Box(Modifier.weight(1f)) {
//
//            }
//        }
//
//        Box(
//            Modifier.fillMaxWidth().height(1.dp).background(lighterBrown)
//        )
//
//        Row(Modifier.weight(1f).fillMaxWidth()) {
//
//            Box(Modifier.weight(1f)) {
//
//            }
//
//            Box(
//                Modifier.fillMaxHeight().width(1.dp).background(lighterBrown)
//            )
//
//            Box(Modifier.weight(1f)) {
//                LeatherButton()
//            }
//        }
//    }
}

val lighterBrown = Color(0xFFd49481)
val lightBrown = Color(0xFFc1765f)
val darkBrown = Color(0xFF211917)

@Composable
fun GodRays() {
    var width by remember { mutableStateOf(0) }
    Box(Modifier.fillMaxSize().onSizeChanged { width = it.width }.background(darkBrown)) {

        val y = remember { Animatable(0f) }

        val degrees = 7f
        LaunchedEffect(Unit) {
            while (true) {
                y.animateTo(-degrees, animationSpec = tween(5000))
                y.animateTo(degrees, animationSpec = tween(5000))
            }
        }

        val maxAlpha = .4f
        val alpha1 = remember { Animatable(0f) }

        LaunchedEffect(Unit) {
            while (true) {
                alpha1.animateTo(0f, animationSpec = tween(4000))
                alpha1.animateTo(maxAlpha, animationSpec = tween(4000))
            }
        }

        val alpha2 = remember { Animatable(maxAlpha) }

        LaunchedEffect(Unit) {
            while (true) {
                alpha2.animateTo(maxAlpha, animationSpec = tween(2000))
                alpha2.animateTo(0f, animationSpec = tween(2000))
            }
        }

        val alphas = remember {
            listOf(
                Animatable(0f),
                Animatable(0f),
                Animatable(0f),
                Animatable(0f),
                Animatable(0f),
            )
        }

        val scope = rememberCoroutineScope()
        LaunchedEffect(Unit) {
            alphas.forEachIndexed { index, animatable ->
                scope.launch {
                    while (true) {
                        val fadeIn = Random(index * currentNanoTime()).nextInt(4, 9) * 1000
                        val fadeOut = Random(index * currentNanoTime()).nextInt(4, 9) * 1000
                        animatable.animateTo(maxAlpha, animationSpec = tween(fadeIn))
                        animatable.animateTo(0f, animationSpec = tween(fadeOut))
                    }
                }
            }
        }

        Box(
            Modifier.fillMaxSize()
                .graphicsLayer {
                    transformOrigin = TransformOrigin(.35f, 0f)
                    rotationZ = y.value
                }
                .scale(1.5f)
                .blur(10.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                .background(
                    brush = Brush.sweepGradient(
                        colors = mutableListOf<Color>().apply {
                            for (i in 0..18) {
                                add(lightBrown.copy(alpha = alphas[i % alphas.size].value))
                                add(darkBrown.copy(alpha = 0f))
                                add(darkBrown.copy(alpha = 0f))
                            }
                            add(lightBrown)
                        },
                        center = Offset(width * .35f, -100f),
                    )
                )
        )

        Box(
            Modifier.fillMaxSize()
                .graphicsLayer {
                    transformOrigin = TransformOrigin(.35f, 0f)
                    rotationZ = -y.value * 1.5f
                }
                .scale(1.5f)
                .blur(24.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                .background(
                    brush = Brush.sweepGradient(
                        colors = mutableListOf<Color>().apply {
                            for (i in 0..18) {
                                add(lightBrown.copy(alpha = alphas[i % alphas.size].value))
                                add(darkBrown.copy(alpha = 0f))
                                add(darkBrown.copy(alpha = 0f))
                            }
                            add(lightBrown)
                        },
                        center = Offset(width * .35f, -100f),
                    )
                )
        )

//        Box(
//            Modifier.fillMaxSize()
//                .onSizeChanged { width = it.width }
//                .blur(25.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
//                .background(
//                    brush = Brush.radialGradient(
//
//
//                        Pair(.3f, Color.Transparent),
//                        Pair(.5f, darkBrown.copy(alpha = .9f)),
//                        Pair(.7f, Color.Transparent),
//
//                        radius = width.toFloat(),
//
//                        center = Offset(width / 2f, -80f),
//                    )
//                )
//        )

        Box(
            Modifier.fillMaxSize()
                .onSizeChanged { width = it.width }
                .blur(25.dp, edgeTreatment = BlurredEdgeTreatment.Rectangle)
                .background(
                    brush = Brush.radialGradient(


                        colors = listOf(
                            lighterBrown.copy(alpha = .2f),
//                            Color.White.copy(alpha = .2f),
                            Color.Transparent,
                            darkBrown
                        ),

                        radius = width.toFloat() * .8f,

                        center = Offset(width / 2f, -200f),
                    )
                )
        )

    }
}

val brown100 = Color(0xFFEDA28E)
val brown200 = Color(0xFFC39C8F)
val brown300 = Color(0xFFe6be87)
val brown500 = Color(0xFF964f3f)
val brown700 = Color(0xFF3D2826)
val brown800 = Color(0xFF58413C)
val yellow300 = Color(0xFFFFE792)

private const val baseFrequency = .4f
private const val size = 4

// Fractal noise shader
private val noiseShader = Shader.makeTurbulence(
    baseFrequencyX = baseFrequency,
    baseFrequencyY = baseFrequency,
    numOctaves = 10,
    seed = 10.0f,
    tileSize = ISize.make(size, size)
)

//#C39C8F, #3D2826

@Composable
fun LeatherButton() {
    Box(Modifier.fillMaxSize()) {

        val interactionSource = remember { MutableInteractionSource() }
        val isHovered by interactionSource.collectIsHoveredAsState()

        val scale by animateFloatAsState(
            targetValue = when {
                isHovered -> 1.01f
                else -> 1f
            },
            animationSpec = spring(
                stiffness = Spring.StiffnessLow,
                dampingRatio = Spring.DampingRatioMediumBouncy,
            ),
            visibilityThreshold = .00000001f
        )

        val highlightScale by animateFloatAsState(
            targetValue = when {
                isHovered -> 1.05f
                else -> 1f
            },
            animationSpec = spring(
                stiffness = Spring.StiffnessVeryLow,
                dampingRatio = Spring.DampingRatioHighBouncy,
            ),
            visibilityThreshold = .00000001f
        )

        Box(
            Modifier
                .pointerHoverIcon(
                    object : PointerIcon {

                    }
                )
                .scale(scale)
                .hoverable(interactionSource)
                .align(Alignment.Center)
                .width(IntrinsicSize.Min)
                .height(IntrinsicSize.Min)
        ) {

            Box(
                Modifier
                    .fillMaxSize()
                    .scale(highlightScale)
                    .background(
                        brown800.copy(alpha = .3f),
                        shape = CircleShape
                    )
            )

            Box(
                Modifier
                    .fillMaxSize()
                    .padding(13.dp)
                    .background(
                        brown100.copy(alpha = .8f),
                        shape = CircleShape
                    )
            )

            Box(
                Modifier
                    .fillMaxSize()
                    .padding(15.dp)
                    .blur(4.dp, BlurredEdgeTreatment.Unbounded)
                    .background(
                        Color.Black.copy(alpha = .6f),
                        shape = CircleShape
                    )
            )

            Box(
                Modifier
                    .fillMaxSize()
                    .padding(16.dp)
                    .background(
                        Brush.linearGradient(colors = listOf(brown200, brown700)),
                        shape = CircleShape
                    )
                    .background(
                        Brush.linearGradient(
                            colors = listOf(
                                Color.Black.copy(alpha = .2f), Color.Black.copy(alpha = .5f),
                            )
                        ),
                        shape = CircleShape
                    )
            )

            Box(Modifier
                .fillMaxSize()
                .padding(16.dp)
                .drawBehind {
                    val roundedPath = Path()
                    roundedPath.addRoundRect(
                        RoundRect(
                            size.toRect(),
                            CornerRadius(size.height)
                        )
                    )

                    drawPath(
                        path = roundedPath,
                        brush = ShaderBrush(
                            shader = noiseShader
                        ),
                        colorFilter = androidx.compose.ui.graphics.ColorFilter.tint(
                            brown100,
                            blendMode = BlendMode.Color
                        ),
                        blendMode = BlendMode.Softlight,
                    )
                }
            )

            Box(Modifier
                .fillMaxSize()
                .padding(18.dp)
                .drawBehind {
                    val roundedPath = Path()
                    roundedPath.addRoundRect(
                        RoundRect(
                            size.toRect(),
                            CornerRadius(size.height)
                        )
                    )

                    drawPath(
                        path = roundedPath,
                        color = Color.White.copy(alpha = .8f),
                        style = Stroke(
                            width = 4f,
                            cap = StrokeCap.Round,
                            pathEffect = PathEffect.dashPathEffect(
                                intervals = floatArrayOf(10f, 15f)
                            )
                        ),
                        blendMode = BlendMode.Softlight
                    )
                })

            Box(Modifier.defaultMinSize(minWidth = 300.dp, minHeight = 100.dp)) {
                Text(
                    "Best Button",
                    modifier = Modifier.align(Alignment.Center),
                    style = TextStyle(
                        fontSize = 32.sp,
                        fontWeight = FontWeight.Medium,
                        brush = Brush.linearGradient(
                            colors = listOf(
                                yellow300,
                                brown300,
                                brown500,
                            )
                        ),
                        shadow = Shadow(
                            color = Color.Black.copy(alpha = .4f),
                            offset = Offset(0f, 4f),
                            blurRadius = 10f,
                        )
                    )
                )
            }

        }


        return
        Box(Modifier
            .align(Alignment.Center)
            .background(
                brown800.copy(alpha = .3f),
                shape = CircleShape
            )
            .padding(12.dp)
//            .customShadow(
//                color = brown700,
//                shape = CircleShape,
//                blurRadius = 4.dp,
//                offsetX = 2.dp,
//                offsetY = 1.dp,
//            )
            .background(
                brown100,
                shape = CircleShape
            )
            .shadow(
                elevation = 2.dp,
                shape = CircleShape,
            )
            .padding(3.dp)
            .background(
                Brush.linearGradient(
                    colors = listOf(
                        brown200, brown700
                    )
                ),
                shape = CircleShape
            )
            .background(
                Brush.linearGradient(
                    colors = listOf(
                        Color.Black.copy(alpha = .2f), Color.Black.copy(alpha = .5f),
                    )
                ),
                shape = CircleShape
            )
            .drawBehind {
                val roundedPath = Path()
                roundedPath.addRoundRect(RoundRect(size.toRect(), CornerRadius(size.height)))

                drawPath(
                    path = roundedPath,
                    brush = ShaderBrush(
                        shader = noiseShader
                    ),
                    colorFilter = androidx.compose.ui.graphics.ColorFilter.tint(
                        brown100,
                        blendMode = BlendMode.Color
                    ),
                    blendMode = BlendMode.Softlight,
                )
            }
            .padding(2.dp)
            .drawBehind {
                val roundedPath = Path()
                roundedPath.addRoundRect(RoundRect(size.toRect(), CornerRadius(size.height)))

                drawPath(
                    path = roundedPath,
                    color = Color.White.copy(alpha = .8f),
                    style = Stroke(
                        width = 4f,
                        cap = StrokeCap.Round,
                        pathEffect = PathEffect.dashPathEffect(
                            intervals = floatArrayOf(10f, 15f)
                        )
                    ),
                    blendMode = BlendMode.Softlight
                )
            }
            .padding(horizontal = 48.dp, vertical = 16.dp)
        ) {
            Text(
                "Best Button",
                style = TextStyle(
                    fontSize = 32.sp,
                    fontWeight = FontWeight.Medium,
                    brush = Brush.linearGradient(
                        colors = listOf(
                            yellow300,
                            brown300,
                            brown500,
                        )
                    ),
                    shadow = Shadow(
                        color = Color.Black.copy(alpha = .4f),
                        offset = Offset(0f, 4f),
                        blurRadius = 10f,
                    )
                )
            )
        }
    }
}


//@Composable
//fun LeatherButton() {
//    Box(Modifier.fillMaxSize()) {
//        Box(Modifier
//            .align(Alignment.Center)
//            .background(
//                brown800.copy(alpha = .3f),
//                shape = CircleShape
//            )
//            .padding(12.dp)
////            .customShadow(
////                color = brown700,
////                shape = CircleShape,
////                blurRadius = 4.dp,
////                offsetX = 2.dp,
////                offsetY = 1.dp,
////            )
//            .background(
//                brown100,
//                shape = CircleShape
//            )
//            .shadow(
//                elevation = 2.dp,
//                shape = CircleShape,
//            )
//            .padding(3.dp)
//            .background(
//                Brush.linearGradient(
//                    colors = listOf(
//                        brown200, brown700
//                    )
//                ),
//                shape = CircleShape
//            )
//            .background(
//                Brush.linearGradient(
//                    colors = listOf(
//                        Color.Black.copy(alpha = .2f), Color.Black.copy(alpha = .5f),
//                    )
//                ),
//                shape = CircleShape
//            )
//            .drawBehind {
//                val roundedPath = Path()
//                roundedPath.addRoundRect(RoundRect(size.toRect(), CornerRadius(size.height)))
//
//                drawPath(
//                    path = roundedPath,
//                    brush = ShaderBrush(
//                        shader = noiseShader
//                    ),
//                    colorFilter = androidx.compose.ui.graphics.ColorFilter.tint(
//                        brown100,
//                        blendMode = BlendMode.Color
//                    ),
//                    blendMode = BlendMode.Softlight,
//                )
//            }
//            .padding(2.dp)
//            .drawBehind {
//                val roundedPath = Path()
//                roundedPath.addRoundRect(RoundRect(size.toRect(), CornerRadius(size.height)))
//
//                drawPath(
//                    path = roundedPath,
//                    color = Color.White.copy(alpha = .8f),
//                    style = Stroke(
//                        width = 4f,
//                        cap = StrokeCap.Round,
//                        pathEffect = PathEffect.dashPathEffect(
//                            intervals = floatArrayOf(10f, 15f)
//                        )
//                    ),
//                    blendMode = BlendMode.Softlight
//                )
//            }
//            .padding(horizontal = 48.dp, vertical = 16.dp)
//        ) {
//            Text(
//                "Best Button",
//                style = TextStyle(
//                    fontSize = 32.sp,
//                    fontWeight = FontWeight.Medium,
//                    brush = Brush.linearGradient(
//                        colors = listOf(
//                            yellow300,
//                            brown300,
//                            brown500,
//                        )
//                    ),
//                    shadow = Shadow(
//                        color = Color.Black.copy(alpha = .4f),
//                        offset = Offset(0f, 4f),
//                        blurRadius = 10f,
//                    )
//                )
//            )
//        }
//    }
//}

@Composable
private fun BoxScope.Particles() {

    for (i in 0..20) {
        Particle()
    }

}


private const val particleOffset = 500
private const val particleMaxFadeDuration = 4000
private const val particleSpeed = 100
private val particleColors = listOf(
    Color(0xffFF9C82),
    Color(0xff9c392a),
    Color(0xff4a2b27),
)

@Composable
private fun BoxScope.Particle() {

    val scope = rememberCoroutineScope()
    val xOffset = remember { Animatable(0f) }
    val yOffset = remember { Animatable(0f) }

    val alpha = remember { Animatable(0f) }
    var size by remember { mutableStateOf(0) }
    var particleColor by remember { mutableStateOf(Color.Transparent) }

    LaunchedEffect(Unit) {


        xOffset.snapTo(Random(currentNanoTime()).nextInt(-particleOffset, particleOffset).toFloat())
        yOffset.snapTo(Random(currentNanoTime()).nextInt(-particleOffset, particleOffset).toFloat())

        while (true) {
            val particleFadeDuration = Random(currentNanoTime()).nextInt(
                particleMaxFadeDuration / 2,
                particleMaxFadeDuration
            )
            size = Random.nextInt(2, 6)
            particleColor = particleColors.random()
            scope.launch {
                xOffset.animateTo(
                    xOffset.value + Random(currentNanoTime()).nextInt(
                        -particleSpeed,
                        particleSpeed
                    ),
                    animationSpec = tween(particleFadeDuration * 2, easing = LinearEasing)
                )
            }
            scope.launch {
                yOffset.animateTo(
                    yOffset.value + Random(currentNanoTime()).nextInt(
                        -particleSpeed,
                        particleSpeed
                    ),
                    animationSpec = tween(particleFadeDuration * 2, easing = LinearEasing)
                )
            }
            alpha.animateTo(
                .7f,
                tween(durationMillis = particleFadeDuration, easing = LinearEasing)
            )
            alpha.animateTo(0f, tween(durationMillis = particleFadeDuration, easing = LinearEasing))
            xOffset.snapTo(
                Random(currentNanoTime()).nextInt(-particleOffset, particleOffset).toFloat()
            )
            yOffset.snapTo(
                Random(currentNanoTime()).nextInt(-particleOffset, particleOffset).toFloat()
            )
        }

    }

    Box(
        Modifier
            .align(Alignment.Center)
            .offset { IntOffset(xOffset.value.toInt(), yOffset.value.toInt()) }
            .alpha(alpha = alpha.value)
            .size(size.dp)
            .background(particleColor, CircleShape)
    )

}

fun Modifier.customShadow(
    color: Color = Color.Black,
    shape: Shape = RectangleShape,
    offsetX: Dp = 0.dp,
    offsetY: Dp = 0.dp,
    blurRadius: Dp = 0.dp,
) = then(
    drawBehind {
        drawIntoCanvas { canvas ->
            val paint = Paint()
            val frameworkPaint = paint.asFrameworkPaint()
            if (blurRadius != 0.dp) {
                frameworkPaint.maskFilter = MaskFilter.makeBlur(
                    mode = FilterBlurMode.NORMAL,
                    sigma = blurRadius.toPx(),
                    respectCTM = false
                )// (BlurMaskFilter(blurRadius.toPx(), NORMAL))
            }
            frameworkPaint.color = color.toArgb()

            val leftPixel = offsetX.toPx()
            val topPixel = offsetY.toPx()

            val path = Path()
            path.addOutline(
                shape.createOutline(
                    size = size,
                    layoutDirection = layoutDirection,
                    density = Density(density, fontScale)
                )
            )
            path.translate(Offset(leftPixel, topPixel))
            canvas.drawPath(
                path, paint
            )
        }
    }
)
